var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchCategoryRobotics32(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-Architecture-Category/32/Robotics_32") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "0%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD0816",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5252",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Architecture-Category/32/Robotics_32",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "url(#linearGradient-1)",
    x: 4,
    y: 4,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    id: "#879196-Border-Copy-21",
    stroke: "#879196",
    strokeWidth: 2,
    x: 1,
    y: 1,
    width: 46,
    height: 46
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon-Category/32/Robotics_32",
    transform: "translate(9.000000, 8.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20,18.9955019 C20.552,18.9955019 21,19.4445019 21,19.9955019 C21,20.5465019 20.552,20.9955019 20,20.9955019 C19.448,20.9955019 19,20.5465019 19,19.9955019 C19,19.4445019 19.448,18.9955019 20,18.9955019 L20,18.9955019 Z M20,21.9955019 C21.103,21.9955019 22,21.0985019 22,19.9955019 C22,18.8925019 21.103,17.9955019 20,17.9955019 C18.897,17.9955019 18,18.8925019 18,19.9955019 C18,21.0985019 18.897,21.9955019 20,21.9955019 L20,21.9955019 Z M12,18.9955019 C12.552,18.9955019 13,19.4445019 13,19.9955019 C13,20.5465019 12.552,20.9955019 12,20.9955019 C11.448,20.9955019 11,20.5465019 11,19.9955019 C11,19.4445019 11.448,18.9955019 12,18.9955019 L12,18.9955019 Z M12,21.9955019 C13.103,21.9955019 14,21.0985019 14,19.9955019 C14,18.8925019 13.103,17.9955019 12,17.9955019 C10.897,17.9955019 10,18.8925019 10,19.9955019 C10,21.0985019 10.897,21.9955019 12,21.9955019 L12,21.9955019 Z M10.233,5.35550191 L9.526,4.64950191 C13.05,1.11950191 18.787,1.11750191 22.316,4.63950191 L21.609,5.34750191 C18.472,2.21350191 13.369,2.21750191 10.233,5.35550191 L10.233,5.35550191 Z M11.256,6.49950191 C13.83,3.92650191 18.016,3.92650191 20.59,6.49950191 L19.883,7.20650191 C17.699,5.02350191 14.146,5.02350191 11.963,7.20650191 L11.256,6.49950191 Z M29,27.1445019 L28,27.9015019 L28,22.1045019 L29,22.8805019 L29,27.1445019 Z M27,28.9955019 L26,28.9955019 L26,20.9905019 C26,20.6535019 25.982,20.3225019 25.953,19.9955019 L27,19.9955019 L27,28.9955019 Z M5,19.9955019 L6.047,19.9955019 C6.018,20.3225019 6,20.6535019 6,20.9905019 L6,28.9955019 L5,28.9955019 L5,19.9955019 Z M3,27.1445019 L3,22.8805019 L4,22.1045019 L4,27.9015019 L3,27.1445019 Z M16,11.9905019 C21.131,11.9905019 25,15.8595019 25,20.9905019 L25,28.9955019 L7,28.9955019 L7,20.9905019 C7,15.8595019 10.869,11.9905019 16,11.9905019 L16,11.9905019 Z M15,8.78150191 C15,8.34850191 15.353,7.99550191 15.786,7.99550191 L16.214,7.99550191 C16.647,7.99550191 17,8.34850191 17,8.78150191 L17,11.0375019 C16.672,11.0085019 16.339,10.9905019 16,10.9905019 C15.661,10.9905019 15.328,11.0085019 15,11.0375019 L15,8.78150191 Z M28,20.8385019 L28,19.4955019 C28,19.2195019 27.776,18.9955019 27.5,18.9955019 L25.814,18.9955019 C25.06,14.9595019 22.035,11.9335019 18,11.1775019 L18,8.78150191 C18,7.79650191 17.199,6.99550191 16.214,6.99550191 L15.786,6.99550191 C14.801,6.99550191 14,7.79650191 14,8.78150191 L14,11.1775019 C9.965,11.9335019 6.94,14.9595019 6.186,18.9955019 L4.5,18.9955019 C4.224,18.9955019 4,19.2195019 4,19.4955019 L4,20.8385019 L2.193,22.2415019 C2.071,22.3355019 2,22.4815019 2,22.6365019 L2,27.3935019 C2,27.5505019 2.073,27.6975019 2.198,27.7925019 L4,29.1555019 L4,29.4955019 C4,29.7715019 4.224,29.9955019 4.5,29.9955019 L27.5,29.9955019 C27.776,29.9955019 28,29.7715019 28,29.4955019 L28,29.1555019 L29.802,27.7925019 C29.927,27.6975019 30,27.5505019 30,27.3935019 L30,22.6365019 C30,22.4815019 29.929,22.3355019 29.807,22.2415019 L28,20.8385019 Z",
    id: "Robotics_Category-Icon_32_Squid"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchCategoryRobotics32);
export default __webpack_public_path__ + "static/media/Arch-Category_Robotics_32.9a6fbe15271f43694e4d0670e374a2b4.svg";
export { ForwardRef as ReactComponent };